import classNames from "classnames";
import { Component, JSX } from "react";

import { TooltipWrapper } from ".";
import { TooltipPlacement } from "./literals";

interface InfoIndicatorProps {
  /** [Optional] Apply custom css class to indicator icon  */
  className?: string;
  /** [Optional] Where to place the tooltip. 'Default: auto' */
  tooltipPlacement?: TooltipPlacement;
  /** [Optional] The width of the tooltop. 'Default: auto' */
  tooltipWidth?: string;
  /** The informational tooltip to be displayed */
  tooltipTitle: string | JSX.Element;
}

/** A standardized way to communicate additional to the user. Renders the Ⓘ with a stylized informational tooltip */
export default class InfoIndicator extends Component<InfoIndicatorProps> {
  public render() {
    const classes = classNames("fa", "fa-info-circle", this.props.className);
    return (
      <TooltipWrapper text={this.props.tooltipTitle} position={this.props.tooltipPlacement} tooltipWidth={this.props.tooltipWidth}>
        <i className={classes} />
      </TooltipWrapper>
    );
  }
}
